import { ADsTrackingDataType, ClickType, NewTracking } from '@/constants/track';
import { trackAdCreative } from '@/api/ads';
import { setClientNavigationPDPAdsAttribution } from '@/utils/common/ads-tracking';

import {
  buttonClick,
  ellipseClick,
  filterBtnClick,
  productClick,
  saveClick,
  sectionClick,
  sortFilterClick,
  commonClick,
  buttonClickFormat,
  customButtonClick,
  sendEvent,
  shareClick,
  formatClick
} from '@weee-fe/weee-biz-web';
// //click_type是view或者normal的标准：点击页面是否看到新的内容，已经出现的不算
const buttonClickView = param => {
  const params = formatClick.formatParam(param);
  params.co = formatClick.formatButton({
    ...(param?.co || {}),
    click_type: ClickType.view
  });
  sendEvent({
    type: NewTracking.clickAction,
    params
  });
};
const popupClick = params => {
  sendEvent({
    type: NewTracking.popup,
    params
  });
};
// click_type: normal_button
const buttonClickExtraParams = params => {
  const _params = formatClick.formatParam(params);
  _params.co = formatClick.formatButton({
    click_type: ClickType.view
  });
  _params.co = {
    ..._params.co,
    ...params.co
  };
  sendEvent({
    type: NewTracking.clickAction,
    params: _params
  });
};

export const commonClickExtend = (params, formatFn = formatClick.formatParam, adsTrackingData?) => {
  const _params = formatClick.formatParam(params);
  _params.co = formatFn({
    click_type: ClickType.view
  });
  _params.co = {
    ..._params.co,
    ...params.co
  };
  /**
   * 说明当前商品卡片是广告位
   * 需要给co增加url和utm_campaign参数
   */
  if (adsTrackingData) {
    const params = new URLSearchParams(adsTrackingData?.trackRedirectUrl);
    const allValues = params.getAll('utm_campaign');

    _params.co = {
      ..._params.co,
      url: adsTrackingData.trackRedirectUrl,
      utm_campaign: allValues[allValues.length - 1]
    };
  }
  sendEvent({
    type: NewTracking.clickAction,
    params: _params
  });
  try {
    if (adsTrackingData && params?.co?.target_nm) {
      if (adsTrackingData?.trackClickUrl) {
        trackAdCreative(adsTrackingData.trackClickUrl, adsTrackingData, params);
        setClientNavigationPDPAdsAttribution(params.co.target_nm, adsTrackingData);
      }
    }
  } catch (e) {}
};

export const clickFillAnyData = params => {
  const _params = formatClick.formatParam(params);
  _params.co = {
    ..._params.co,
    ...params.co
  };
  sendEvent({
    type: NewTracking.clickAction,
    params: _params
  });
};

export const bannerClick = params => {
  if (!params) return;
  const { banner_id, banner_key, url, target_nm, banner_pos, banner_type, target_type, target_pos } = params?.co || {};
  const _params = {
    ...params
  };
  _params.co = {
    target_nm: banner_id || target_nm,
    target_pos: banner_pos || target_pos,
    target_type: banner_type || target_type,
    click_type: ClickType.view,
    url: url
  };
  sendEvent({
    type: NewTracking.clickAction,
    params: _params
  });
};

export default function useClickActionT2(adsTrackingData?: ADsTrackingDataType) {
  return {
    bannerClick,
    buttonClick,
    buttonClickExtraParams,
    ellipseClick,
    filterBtnClick,
    productClick: params => commonClickExtend(params, formatClick.formatProduct, adsTrackingData),
    saveClick,
    sectionClick,
    sortFilterClick,
    shareClick,
    commonClick,
    buttonClickFormat,
    customButtonClick,
    buttonClickView,
    popupClick,
    clickFillAnyData
  };
}
